import * as React from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { CustomChartByDateTooltip } from '../CustomTooltip/CustomTooltip';

export interface IChartProps {
  data: any;
  dateKey: string;
  dataKey: string;
}

export const ChartByDate = ({ data, dataKey, dateKey }: IChartProps) => (
  <ResponsiveContainer width={'95%'} height={310}>
    <AreaChart height={400} data={data}>
      <CartesianGrid strokeDasharray="3 3" />
      <XAxis dataKey={dateKey} />
      <YAxis />
      <Tooltip content={<CustomChartByDateTooltip dataKey={dataKey} dateKey={dateKey} />} />
      {data.length > 0 && <Area type='monotone' dataKey={dataKey} stroke={'#E2BC2F'} fill={'#E2BC2F'} />}
      {data.length === 0 && <Area type='monotone' dataKey='No Data to Show' stroke='grey' fill='grey' />}
    </AreaChart>
  </ResponsiveContainer>
)



// WEBPACK FOOTER //
// ./src/share/components/Chart/ChartByDate.tsx